<template>
  <div
    class="neg-card"
    :class="'neg-card--' + oportunidade.alerta_nivel"
    :draggable="arrastavel"
    @dragstart="iniciaArraste"
    @dragend="$emit('fim-arraste')"
    @click="$emit('abrir', oportunidade)"
  >
    <div class="neg-card__topo">
      <span class="neg-card__codigo">{{ oportunidade.codigo }}</span>
      <q-badge
        v-if="alerta"
        :color="corDoAlertaNegocios(oportunidade.alerta_nivel)"
        :text-color="textoDoAlertaNegocios(oportunidade.alerta_nivel)"
      >{{ alerta }}</q-badge>
    </div>
    <div class="neg-card__nome" :title="tituloDoCliente">{{ nomeDoCliente }}</div>
    <div class="neg-card__linha" :title="tituloDaLinha">{{ nomeDaLinha }}</div>
    <div class="neg-card__rodape">
      <span class="neg-card__valor">{{ formatarMoeda(valor) }}</span>
      <span class="neg-card__dias">{{ rotuloDeDiasNaEtapa(oportunidade.dias_na_etapa) }}</span>
    </div>
    <div
      v-if="checklist"
      class="neg-card__checklist"
      :class="{ 'neg-card__checklist--completo': checklist.completo }"
    >
      <q-icon name="fact_check" size="14px" />
      <span>{{ checklist.marcados }}/{{ checklist.total }} documentos</span>
    </div>
  </div>
</template>

<script>
import negociosMixin from "@/mixins/negocios";

export default {
  name: "negocios-card",

  emits: ["abrir", "arrastar", "fim-arraste"],
  mixins: [negociosMixin],
  props: {
    oportunidade: {
      type: Object,
      required: true
    },
    arrastavel: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    alerta() {
      return this.rotuloDoAlerta(this.oportunidade.data_alerta);
    },
    valor() {
      return this.valorDaOportunidade(this.oportunidade);
    },
    checklist() {
      return this.oportunidade.checklist_progresso || null;
    },
    nomeDoCliente() {
      return this.oportunidade.cliente ? this.oportunidade.cliente.nome : "Cliente removido";
    },
    nomeDaLinha() {
      return this.resumoDeLinhas(this.oportunidade).texto;
    },
    tituloDaLinha() {
      return this.resumoDeLinhas(this.oportunidade).titulo;
    },
    tituloDoCliente() {
      const documento = this.oportunidade.cliente ? this.oportunidade.cliente.cpfcnpj : null;

      return documento ? this.nomeDoCliente + " · " + documento : this.nomeDoCliente;
    }
  },
  methods: {
    iniciaArraste(evento) {
      if (!this.arrastavel) {
        return;
      }

      if (evento.dataTransfer) {
        evento.dataTransfer.effectAllowed = "move";
        evento.dataTransfer.setData("text/plain", String(this.oportunidade.id));
      }

      this.$emit("arrastar", this.oportunidade);
    }
  }
};
</script>
